import { useState } from 'react';
import { Button, Tabs } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { RolesUser } from 'shared/enums';
import { configTabs } from 'shared/helpers/utils';
import { useTabsNavigate } from 'shared/hooks';
import { TItemsTab } from 'shared/types/types';
import AbsenceArchive from './absenceArchive';
import AbsencePull from './absencePull';
import style from './index.module.scss';
import ModalAddOneAbsence from './madalAddOneAbsence';

const allRoles = [
  RolesUser.HRDirector,
  RolesUser.Consultant,
  RolesUser.Employee,
  RolesUser.FirstLine,
  RolesUser.SecondLine,
];

const itemsTab: TItemsTab = [
  {
    label: 'Общий список заявок',
    key: 'new',
    children: <AbsencePull />,
    role: allRoles,
  },

  {
    label: 'Архив',
    key: 'myArchive',
    children: <AbsenceArchive />,
    role: allRoles,
  },
];

const AbsenceSupervisor = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, handler] = useTabsNavigate('absence', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tabPane = configTabs(role, itemsTab);
  const openModal = () => setIsModalOpen(true);

  return (
    <>
      <div className={style.absence__panel}>
        <h3>Неявки подчиненных</h3>
        <div className={style.btnGroup}>
          <Button type="primary" icon={<PlusOutlined />} onClick={openModal}>
            Добавить
          </Button>
        </div>
      </div>

      <div className={style.wrap}>
        <AbsencePull />
      </div>
      <ModalAddOneAbsence isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </>
  );
};

export default AbsenceSupervisor;
